/** Convert "YYYY-MM-DD" → "DD/MM/YYYY". Returns original string if format is unrecognised. */
export function formatDate(dateStr) {
  if (!dateStr) return "";
  const parts = dateStr.split("-");
  if (parts.length !== 3 || parts[0].length !== 4) return dateStr;
  return `${parts[2]}/${parts[1]}/${parts[0]}`;
}
